import React from 'react';

import YandexListener from './YandexListener';

const YAMetricsProvider = () => {
  return <YandexListener />;
};

export default YAMetricsProvider;
